<template>
  <div id="gauge" :style="bgc">
    <GChart 
      :settings="({packages: ['gauge']})"
      type="Gauge"
      :data="args.values"
      :options="chartOptions"
      :resizeDebounce="500"
      @ready="onChartReady"
    >
    </GChart>
  </div>
</template>

<script >
import { GChart } from 'vue-google-charts'
import { sync } from 'vuex-pathify'
import ui from '@/../../coreui/helpers/ui'

export default {
  props: ['args', 'size'],
  components: {
    GChart,
  },
  computed: {
    dark: sync('misc/dark'),
    bgc() {
      return  {
        backgroundColor: ui.theme(this.dark).background,
        height: '100%'
      }
    },
    chartOptions () {
      return {
        values: this.args.values,
        colors: ui.theme(this.dark).palette,
        backgroundColor: ui.theme(this.dark).backgroundcolor,
        // width: this.args.width, 
        // height: this.args.height, 
        width: this.size,
        height: this.size,
        legend: {textStyle: ui.theme(this.dark).legend},
        vAxis: {
          textStyle: ui.theme(this.dark).legend
        },
        greenFrom: this.args.green != undefined? this.args.green.from : null,
        greenTo: this.args.green != undefined ? this.args.green.to : null,
        redFrom: this.args.red.from,
        redTo: this.args.red.to,
        yellowFrom: this.args.yellow.from,
        yellowTo: this.args.yellow.to,
        titleTextStyle: ui.theme(this.dark).title,
      }
      
    }
  },
  watch: {
    // legend: {
    //   immediate: true,
    //   handler( val, old) {
    //     // this.pie.legend.data = val
    //   }
    // },
    // values: {
    //   immediate: true,
    //   handler( val, old) {
    //     // this.pie.dataset.source = val
    //   }
    // },
    // name: {
    //   immediate: true,
    //   handler( val, old) {
    //     // this.pie.series.name = val
    //   }
    // },
    // title: {
    //   immediate: true,
    //   handler( val, old) {
    //     // this.pie.title.text = val
    //   }
    // },
    // subtitle: {
    //   immediate: true,
    //   handler( val, old) {
    //     // this.pie.title.subtext = val
    //   }
    // }
  },
  data () {
    var self = this
    return {
      data:[]
    }
  },
  methods: {
    onChartReady (chart, google) {
      // console.log(this.$refs)
      google.visualization.events.addListener(chart, 'ready', function() {
        
        // this.$refs('#gauge circle:nth-child(2)').attr('fill', '#FF0000')
      })
      // console.log('onChartReady: ', chart, google)
    },
  },
  beforeMount () {
    
  },
  mounted () {
    // console.log(uix, utils)
    // this.$nextTick(function() {
    //       console.log(this.$refs.gauge)
    // })
  },
  created () {
  },
  destroyed () {
  }
}
</script>

<style scoped>
</style>